var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCowbell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.591 135.511C382.482 112.642 362.583 96 339.348 96H320.59V48C320.59 21.49 299.099 0 272.59 0H176.215C149.705 0 128.215 21.49 128.215 48V96H108.614C85.379 96 65.48 112.642 61.37 135.511L0.481 474.375C-2.849 493.33 11.488 512 32.106 512H415.856C436.504 512 450.807 493.311 447.481 474.375L386.591 135.511ZM175.965 48H271.965V96H175.965V48ZM51.106 464L108.606 144H339.356L396.856 464H51.106Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowbell);
export default __webpack_public_path__ + "static/media/cowbell.62b2e0903e5514a01c47286deb58f99e.svg";
export { ForwardRef as ReactComponent };